/**
 * Cognito User Pool Group Constants
 *
 * Group names used for authorization and feature access control.
 */
export const COGNITO_GROUPS = {
  DEV: 'dev',
  OPERATIONS: 'operations',
  PRIMUM: 'primum',
  PHARMA: 'pharma',
} as const;

export type CognitoGroup = (typeof COGNITO_GROUPS)[keyof typeof COGNITO_GROUPS];
